const CHUNK_RELOAD_GUARD_KEY = 'async-error-boundary-chunk-reload';

export const isDynamicImportFailure = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error || '');
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('ChunkLoadError')
  );
};

export const clearDynamicImportRecoveryGuard = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
  } catch {
    // Ignore storage failures.
  }
};

export const scheduleDynamicImportRecoveryGuardClear = (delayMs = 15000): number | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.setTimeout(() => {
    clearDynamicImportRecoveryGuard();
  }, delayMs);
};

export const tryRecoverFromDynamicImportFailure = (error: unknown): boolean => {
  if (typeof window === 'undefined' || !isDynamicImportFailure(error)) {
    return false;
  }

  try {
    if (window.sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === '1') {
      return false;
    }
    window.sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, '1');
  } catch {
    return false;
  }

  window.location.reload();
  return true;
};
